import React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Facebook, Twitter, Instagram, LinkedIn } from '@mui/icons-material';

function Footer() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <footer style={{
      backgroundColor: '#1c30a0ff',
      color: 'white',
      padding: '60px 0 30px',
      position: 'relative',
      width: '100%',
    }}>
      <div className="container" style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: isMobile ? '0 20px' : '0 40px'
      }}>
        <div className="footer-content" style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          justifyContent: 'space-between',
          marginBottom: '40px',
          gap: '40px'
        }}>
          <div className="footer-about" style={{
            flex: isMobile ? '1 1 100%' : '0 0 40%'
          }}>
            <h3 style={{
              fontSize: '1.5rem',
              fontWeight: 700,
              marginBottom: '20px',
              color: '#4fc3f7'
            }}>
              VoteVocal
            </h3>
            <p style={{
              lineHeight: 1.6,
              opacity: 0.9,
              marginBottom: '20px'
            }}>
              Empowering democracy through technology. Stay informed and engaged with your representatives.
            </p>
            {/* <div className="social-links" style={{
              display: 'flex',
              gap: '15px'
            }}>
              <a href="#" aria-label="Facebook" style={{
                color: 'white',
                transition: 'all 0.3s ease',
                opacity: 0.8
              }} onMouseEnter={(e) => e.currentTarget.style.opacity = '1'} 
              onMouseLeave={(e) => e.currentTarget.style.opacity = '0.8'}>
                <Facebook fontSize="medium" />
              </a>
              <a href="#" aria-label="Twitter" style={{
                color: 'white',
                transition: 'all 0.3s ease',
                opacity: 0.8
              }} onMouseEnter={(e) => e.currentTarget.style.opacity = '1'} 
              onMouseLeave={(e) => e.currentTarget.style.opacity = '0.8'}>
                <Twitter fontSize="medium" />
              </a>
              <a href="#" aria-label="Instagram" style={{
                color: 'white',
                transition: 'all 0.3s ease',
                opacity: 0.8
              }} onMouseEnter={(e) => e.currentTarget.style.opacity = '1'} 
              onMouseLeave={(e) => e.currentTarget.style.opacity = '0.8'}>
                <Instagram fontSize="medium" />
              </a>
              <a href="#" aria-label="LinkedIn" style={{
                color: 'white',
                transition: 'all 0.3s ease',
                opacity: 0.8
              }} onMouseEnter={(e) => e.currentTarget.style.opacity = '1'} 
              onMouseLeave={(e) => e.currentTarget.style.opacity = '0.8'}>
                <LinkedIn fontSize="medium" />
              </a>
            </div> */}
          </div>

          <div className="footer-links" style={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            gap: isMobile ? '30px' : '60px'
          }}>
            <div className="links-column">
              <h4 style={{
                fontSize: '1.1rem',
                fontWeight: 600,
                marginBottom: '20px',
                textTransform: 'uppercase',
                letterSpacing: '1px'
              }}>
                Resources
              </h4>
              <ul style={{
                listStyle: 'none',
                padding: 0,
                margin: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: '12px'
              }}>
                <li>
                  <a href="./privacy" style={{
                    color: 'white',
                    textDecoration: 'none',
                    opacity: 0.8,
                    transition: 'all 0.3s ease',
                    display: 'inline-block'
                  }} 
                  onMouseEnter={(e) => {
                    e.currentTarget.style.opacity = '1';
                    e.currentTarget.style.transform = 'translateX(5px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.opacity = '0.8';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}>
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="./marketing" style={{
                    color: 'white',
                    textDecoration: 'none',
                    opacity: 0.8,
                    transition: 'all 0.3s ease',
                    display: 'inline-block'
                  }} 
                  onMouseEnter={(e) => {
                    e.currentTarget.style.opacity = '1';
                    e.currentTarget.style.transform = 'translateX(5px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.opacity = '0.8';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}>
                    Marketing Policy
                  </a>
                </li>
                <li>
                  <a href="./terms-and-conditions" style={{
                    color: 'white',
                    textDecoration: 'none',
                    opacity: 0.8,
                    transition: 'all 0.3s ease',
                    display: 'inline-block'
                  }} 
                  onMouseEnter={(e) => {
                    e.currentTarget.style.opacity = '1';
                    e.currentTarget.style.transform = 'translateX(5px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.opacity = '0.8';
                    e.currentTarget.style.transform = 'translateX(0)';
                  }}>
                    Terms & Conditions
                  </a>
                </li>
              </ul>
            </div>

            <div className="links-column">
              <h4 style={{
                fontSize: '1.1rem',
                fontWeight: 600,
                marginBottom: '20px',
                textTransform: 'uppercase',
                letterSpacing: '1px'
              }}>
                Contact
              </h4>
              <ul style={{
                listStyle: 'none',
                padding: 0,
                margin: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: '12px',
                opacity: 0.8
              }}>
                <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M22 6L12 13L2 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span>support@votevocal.com</span>
                </li>
                {/* <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22 16.92V19.92C22 20.47 21.55 20.92 21 20.92H19C18.45 20.92 18 20.47 18 19.92V16.92C18 16.37 18.45 15.92 19 15.92H21C21.55 15.92 22 16.37 22 16.92Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 16.92V19.92C16 20.47 15.55 20.92 15 20.92H13C12.45 20.92 12 20.47 12 19.92V16.92C12 16.37 12.45 15.92 13 15.92H15C15.55 15.92 16 16.37 16 16.92Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M22 10V13C22 13.55 21.55 14 21 14H19C18.45 14 18 13.55 18 13V10C18 9.45 18.45 9 19 9H21C21.55 9 22 9.45 22 10Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 10V13C16 13.55 15.55 14 15 14H13C12.45 14 12 13.55 12 13V10C12 9.45 12.45 9 13 9H15C15.55 9 16 9.45 16 10Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 16.92V19.92C10 20.47 9.55 20.92 9 20.92H3C2.45 20.92 2 20.47 2 19.92V16.92C2 16.37 2.45 15.92 3 15.92H9C9.55 15.92 10 16.37 10 16.92Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M10 10V13C10 13.55 9.55 14 9 14H3C2.45 14 2 13.55 2 13V10C2 9.45 2.45 9 3 9H9C9.55 9 10 9.45 10 10Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span>+1 (555) 123-4567</span>
                </li>
                <li style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  <span>123 Democracy Ave, Washington DC</span>
                </li> */}
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom" style={{
          borderTop: '1px solid rgba(255,255,255,0.1)',
          paddingTop: '30px',
          textAlign: 'center'
        }}>
          <p style={{
            margin: 0,
            opacity: 0.7,
            fontSize: '0.9rem'
          }}>
            © {new Date().getFullYear()} VoteVocal. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;